<!-- CollectionSourceTransactions.vue -->
<template>
  <div>
    <!-- Modal -->
    <div class="modal fade" id="transactionsModal" tabindex="-1" aria-labelledby="transactionsModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="transactionsModalLabel">
              <i class="bx bx-list-ul me-2"></i>Transactions for {{sourceDetails.shortCodeName}}
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <!-- Summary Cards -->
            <div class="row mb-3">
              <div class="col-md-4">
                <div class="card border">
                  <div class="card-body p-3">
                    <h6 class="text-muted mb-2">Account Details</h6>
                    <p class="mb-1"><strong>Type:</strong>
                      <span class="badge" :class="sourceDetails.collectionType === 'MPESA' ? 'bg-info' : 'bg-warning'">
                        {{sourceDetails.collectionType}}
                      </span>
                    </p>
                    <p class="mb-0"><strong>Account:</strong> <code>{{sourceDetails.short_code}}</code></p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="card border">
                  <div class="card-body p-3">
                    <h6 class="text-muted mb-2">Date Range</h6>
                    <p class="mb-0">{{dateFrom}} to {{dateTo}}</p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="card border">
                  <div class="card-body p-3">
                    <h6 class="text-muted mb-2">Total Amount</h6>
                    <h5 class="mb-0 text-primary">{{formatPrice(totalAmount)}}</h5>
                  </div>
                </div>
              </div>
            </div>

            <!-- Search Bar -->
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="input-group">
                  <span class="input-group-text"><i class="bx bx-search"></i></span>
                  <input v-model="searchQuery" class="form-control" placeholder="Search by transaction code, name, location, income type..." type="text">
                </div>
              </div>
              <div class="col-md-6 text-end">
                <button @click="exportTransactions" class="btn btn-success btn-sm" :disabled="transactions.length === 0">
                  <i class="mdi mdi-download"></i> Export to CSV
                </button>
              </div>
            </div>

            <!-- Transactions Table -->
            <div class="table-responsive" style="max-height: 400px; overflow-y: auto;">
              <table class="table table-sm table-hover">
                <thead class="table-light sticky-top">
                <tr>
                  <th width="3%">#</th>
                  <th width="10%">Date</th>
                  <th width="12%">Transaction Code</th>
                  <th width="10%">From</th>
                  <th width="15%">Name</th>
                  <th width="10%">Location</th>
                  <th width="15%">Income Type</th>
                  <th width="15%">Description</th>
                  <th width="5%">Reference</th>
                  <th width="5%" class="text-end">Amount</th>
                </tr>
                </thead>
                <tbody v-if="!loading && filteredTransactions.length > 0">
                <tr v-for="(txn, index) in filteredTransactions" :key="txn.transaction_code">
                  <td>{{index + 1}}</td>
                  <td>
                    <small>{{formatDate(txn.date)}}</small>
                  </td>
                  <td>
                    <code class="text-primary">{{txn.transaction_code}}</code>
                  </td>
                  <td>
                    <small>{{txn.account_from}}</small>
                  </td>
                  <td>
                    <small class="text-capitalize">{{txn.names.toLowerCase()}}</small>
                  </td>
                  <td>
                    <small class="text-muted">
                      <span v-if="txn.wardName">{{txn.wardName}}</span>
                      <span v-else-if="txn.subCountyName">{{txn.subCountyName}}</span>
                      <span v-else-if="txn.zone">{{txn.zone}}</span>
                      <span v-else>-</span>
                    </small>
                  </td>
                  <td>
                    <small>
                      <span v-if="txn.incomeTypeDescription" class="text-info">{{txn.incomeTypeDescription}}</span>
                      <span v-else-if="txn.incomeTypePrefix" class="text-muted">{{txn.incomeTypePrefix}}</span>
                      <span v-else>-</span>
                    </small>
                  </td>
                  <td>
                    <small class="text-muted">
                      <span v-if="txn.description">{{txn.description}}</span>
                      <span v-else-if="txn.feeDescription">{{txn.feeDescription}}</span>
                      <span v-else>-</span>
                    </small>
                  </td>
                  <td>
                    <small>{{txn.account_ref}}</small>
                  </td>
                  <td class="text-end">
                    <strong>{{formatPrice(txn.amount)}}</strong>
                  </td>
                </tr>
                </tbody>
                <tbody v-else-if="loading">
                <tr>
                  <td colspan="10" class="text-center py-4">
                    <div class="spinner-border spinner-border-sm text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-2 mb-0">Loading transactions...</p>
                  </td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                  <td colspan="10" class="text-center py-4">
                    <p class="mb-0 text-muted">No transactions found</p>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <!-- Footer Summary -->
            <div class="row mt-3 pt-3 border-top" v-if="transactions.length > 0">
              <div class="col-6">
                <small class="text-muted">
                  Showing {{filteredTransactions.length}} of {{transactions.length}} transactions
                </small>
              </div>
              <div class="col-6 text-end">
                <small class="text-muted">
                  Total: <strong class="text-primary">{{formatPrice(filteredTotal)}}</strong>
                </small>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {execute2, biller} from "@/api";
import moment from 'moment';

export default {
  name: "CollectionSourceTransactions",
  props: {
    sourceDetails: {
      type: Object,
      default: () => ({})
    },
    dateFrom: String,
    dateTo: String
  },
  data() {
    return {
      loading: false,
      transactions: [],
      searchQuery: '',
      totalAmount: 0
    }
  },
  computed: {
    filteredTransactions() {
      if (!this.searchQuery) return this.transactions;

      const query = this.searchQuery.toLowerCase();
      return this.transactions.filter(txn =>
          txn.transaction_code.toLowerCase().includes(query) ||
          txn.names.toLowerCase().includes(query) ||
          txn.account_ref.toLowerCase().includes(query) ||
          txn.account_from.toLowerCase().includes(query) ||
          (txn.wardName && txn.wardName.toLowerCase().includes(query)) ||
          (txn.subCountyName && txn.subCountyName.toLowerCase().includes(query)) ||
          (txn.zone && txn.zone.toLowerCase().includes(query)) ||
          (txn.incomeTypeDescription && txn.incomeTypeDescription.toLowerCase().includes(query)) ||
          (txn.description && txn.description.toLowerCase().includes(query))
      );
    },

    filteredTotal() {
      return this.filteredTransactions.reduce((sum, txn) => sum + parseFloat(txn.amount || 0), 0);
    }
  },
  methods: {
    loadTransactions() {
      this.loading = true;
      this.transactions = [];

      const data = new FormData();
      data.append("function", "getCollectionSourceTransactions");
      data.append("account_to", this.sourceDetails.short_code);
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);

      execute2(data, biller)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.transactions = res.data.data.transactions;
              this.totalAmount = res.data.data.totalAmount;
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => {
            this.loading = false;
            alert("Error loading transactions: " + e.message);
          });
    },

    formatDate(date) {
      return moment(date).format('MMM D, YYYY h:mm A');
    },

    formatPrice(value) {
      const formatter = new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
      return formatter.format(value);
    },

    exportTransactions() {
      if (this.filteredTransactions.length === 0) {
        alert('No transactions to export');
        return;
      }

      // Prepare CSV content
      const headers = ['#', 'Date', 'Transaction Code', 'From', 'Name', 'Ward', 'SubCounty', 'Zone', 'Income Type', 'Description', 'Reference', 'Amount'];
      const csvContent = [
        headers.join(','),
        ...this.filteredTransactions.map((txn, index) => [
          index + 1,
          this.formatDate(txn.date),
          txn.transaction_code,
          `"${txn.account_from}"`,
          `"${txn.names}"`,
          `"${txn.wardName || ''}"`,
          `"${txn.subCountyName || ''}"`,
          `"${txn.zone || ''}"`,
          `"${txn.incomeTypeDescription || txn.incomeTypePrefix || ''}"`,
          `"${txn.description || txn.feeDescription || ''}"`,
          txn.account_ref,
          txn.amount
        ].join(','))
      ].join('\n');

      // Add summary
      const summaryContent = `\n\nSummary\nAccount:,${this.sourceDetails.shortCodeName}\nAccount Number:,${this.sourceDetails.short_code}\nDate Range:,${this.dateFrom} to ${this.dateTo}\nTotal Transactions:,${this.filteredTransactions.length}\nTotal Amount:,${this.filteredTotal}`;

      // Create blob and download
      const blob = new Blob([csvContent + summaryContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      link.setAttribute('href', url);
      link.setAttribute('download', `${this.sourceDetails.short_code}_transactions_${this.dateFrom}_to_${this.dateTo}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    show() {
      // Load transactions when modal is shown
      this.loadTransactions();

      // Show the modal using Bootstrap
      const modal = new bootstrap.Modal(document.getElementById('transactionsModal'));
      modal.show();
    }
  }
}
</script>

<style scoped>
.table-responsive::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-responsive::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.table-responsive::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.table-responsive::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>